import pnlCluster from '../images/markers/cluster.svg';

export const DEFAULT_BOUNDS = {
    sw: {
        lat: 49.6612,
        lng: 2.4713,
    },
    ne: {
        lat: 51.4774,
        lng: 6.4024,
    },
};

export const CLUSTERER_OPTIONS = {
    styles: [
        {
            height: 70,
            url: pnlCluster,
            width: 70,
            textColor: 'white',
            fontWeight: 700,
            textLineHeight: 70,
        },
    ],
};

export const MAP_STYLES: google.maps.MapTypeStyle[] = [
    {
        featureType: 'poi',
        elementType: 'labels',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
    {
        featureType: 'road',
        elementType: 'labels',
        stylers: [
            {
                visibility: 'off',
            },
        ],
    },
];
